// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

const unitless = (str, unit = `rem`) => Number(str.replace(unit, ``))

export default unitless
